module.exports = __webpack_public_path__ + "92a3694f5a8659645bdc4e30050a961c.svg";